/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { useSelector } from 'react-redux';

import css from './sub-heading-header.scss';

import {
    ALL_CLASSES,
    ALL_GROUPS,
    ALL_STUDENTS,
    ALL_YEARS,
    ALL_TEACHERS,
    ALL_TEACHERS_TRANS,
    ALL_YEARS_TRANS,
    SELECTED_CLASS,
    SELECTED_DATE,
    SELECTED_GROUP,
    SELECTED_STUDENT,
    SELECTED_YEAR_GROUP,
    SELECTED_TEACHER
} from '../../report-filters/filter-constants';
import activeFiltersSelectors from '../../report-filters/redux/active-filters/active-filters-selectors';
import { getDateRange } from '../sub-heading-helpers';
import { translate } from '../../../helpers/locale-helpers';

const SubHeadingHeader = ({ isModal }) => {
    const { i18n } = window;
    const activeFilters = useSelector((state) =>
        activeFiltersSelectors.selectActiveFilters(state)
    );

    const academicYear = useSelector((state) => state.academicYear);
    const isAdmin = useSelector((state) => state.isAdmin);
    const [label, setLabel] = useState('');
    const [dateRange, setDateRange] = useState('');
    const getTitleNames = () => ({
        className: activeFilters[SELECTED_CLASS].name,
        groupName: activeFilters[SELECTED_GROUP].name,
        studentName: activeFilters[SELECTED_STUDENT].name,
        yearGroup: activeFilters[SELECTED_YEAR_GROUP].name,
        teacherName: activeFilters[SELECTED_TEACHER].name
    });

    const getLabelText = () => {
        const {
            className,
            groupName,
            studentName,
            yearGroup,
            teacherName
        } = getTitleNames();
        let updatedLabel = '';

        if (isAdmin) {
            if (yearGroup === ALL_YEARS && teacherName === ALL_TEACHERS) {
                updatedLabel = `${translate(ALL_YEARS_TRANS)} | ${translate(ALL_TEACHERS_TRANS)}`
            } else if (yearGroup === ALL_YEARS && teacherName !== ALL_TEACHERS) {
                updatedLabel = `${translate(ALL_YEARS_TRANS)} | ${teacherName}`
            } else if (yearGroup !== ALL_YEARS && teacherName === ALL_TEACHERS) {
                updatedLabel = `${yearGroup} | ${translate(ALL_TEACHERS_TRANS)}`
            } else {
                updatedLabel = `${yearGroup} | ${teacherName}`
            }
        }
        updatedLabel = updatedLabel || ALL_CLASSES;
        if (className && className !== ALL_CLASSES) {
            updatedLabel = className;
        }
        if (groupName && groupName !== ALL_GROUPS) {
            updatedLabel = `${updatedLabel} | ${groupName}`;
        }
        if (studentName && studentName !== ALL_STUDENTS) {
            updatedLabel = studentName;
        }
        return updatedLabel;
    };

    const getTranslatedLabel = (translatedLabel) => {
        if (translatedLabel === ALL_CLASSES) {
            const key = `Report Filters - ${translatedLabel}`;

            return i18n._(key);
        }

        return translatedLabel;
    };

    useEffect(
        () => {
            if (isAdmin !== null) {
                const updatedLabel = getLabelText();
                const updatedDateRange = getDateRange(
                    activeFilters[SELECTED_DATE],
                    academicYear
                );

                setLabel(getTranslatedLabel(updatedLabel));
                setDateRange(updatedDateRange);
            }
        },
        [activeFilters, isAdmin, academicYear]
    );

    return (
        isModal ?
            <div className={css.subheader}>
                <div>{label} | {dateRange}</div>
            </div>
            :
            <div className={css.header}>
                <h2>{label}</h2>
                <div className={css['date-range']}>{dateRange}</div>
            </div>
    );
};

SubHeadingHeader.propTypes = {
    isModal: PropTypes.bool
};

export default styleable(css)(SubHeadingHeader);



// WEBPACK FOOTER //
// ./components/sub-heading/sub-heading-header/sub-heading-header.js